module.exports = __webpack_public_path__ + "officialStatic/img/detail-self2.05aaef6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-self2.png
// module id = XTSf
// module chunks = 0